/*
 * Slim v5.3.1 - Image Cropping Made Easy
 * Copyright (c) 2020 Rik Schennink - https://pqina.nl/slim
 */
// Necessary React Modules
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

// Slim (place slim CSS and module js file in same folder as this file)
import Slim from './slim.module.js';
import './slim.min.css';

// React Component
export default class extends React.Component {
  componentDidMount() {
    // eslint-disable-next-line
    const root = ReactDOM.findDOMNode(this);
    if (this.props.initialImage) {
      const img = document.createElement('img');
      img.setAttribute('alt', '');
      img.src = this.props.initialImage;
      root.appendChild(img);
    }
    this.instance = Slim ? Slim.create(root, this.props) : null;
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}
